import { render, staticRenderFns } from "./ChineesIntro.vue?vue&type=template&id=82e80318&"
import script from "./ChineesIntro.vue?vue&type=script&lang=js&"
export * from "./ChineesIntro.vue?vue&type=script&lang=js&"
import style0 from "./ChineesIntro.vue?vue&type=style&index=0&id=82e80318&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports